var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 8.775L14.275.3c.2-.2.438-.3.713-.3.274 0 .512.1.712.3.2.2.3.438.3.712 0 .276-.1.513-.3.713l-9.2 9.2c-.2.2-.433.3-.7.3a.96.96 0 01-.7-.3l-4.3-4.3a.93.93 0 01-.288-.713A1.02 1.02 0 01.825 5.2c.2-.2.437-.3.712-.3.275 0 .513.1.713.3L5.8 8.775z"
  })));
}
export default SvgDone;